import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3" }
const _hoisted_2 = { class: "p-3 flex content-main gap-5" }
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5" }
const _hoisted_5 = { class: "self-stretch py-2 inline-flex flex-col justify-start items-start gap-2" }
const _hoisted_6 = { class: "inline-flex justify-start items-start gap-4" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_9 = { class: "flex items-center w-[320px] mt-2" }
const _hoisted_10 = { class: "placeholder-white block bg-theme-modal_inner_bg pl-3 w-full focus:outline-0 text-sm text-theme-white border-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_CategoryWithProductModal = _resolveComponent("CategoryWithProductModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Nav),
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex justify-between mt-5 h-[40px]" }, [
              _createElementVNode("h2", { class: "text-[24px] font-semibold text-white" }, "Scanners")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "justify-center text-white text-base font-normal font-['Roboto'] leading-5" }, "Require verification", -1)),
                _createElementVNode("label", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.enableScannerVerification.value) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateScanner())),
                    class: "hidden peer"
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.form.enableScannerVerification.value]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full cursor-pointer ' + (_ctx.form.enableScannerVerification.value ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                  }, null, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.enableScannerVerification.value ? 'text-theme-green' : 'text-[#F53333]'])
                  }, _toDisplayString(_ctx.form.enableScannerVerification.value ? 'On' : 'Off'), 3)
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "justify-center text-white text-sm font-normal font-['Roboto'] leading-4" }, "Default is off. If toggled on, the scanning flow changes to REQUIRE a scanned product before orders are completed.", -1)),
              (_ctx.form?.enableScannerVerification?.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "justify-center text-white text-base font-normal font-['Roboto'] leading-5" }, "Select products to exempt from forced scan verification", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.selectedCatIds.length) + " category, " + _toDisplayString(_ctx.selectedPids.length) + " item" + _toDisplayString(_ctx.selectedPids.length > 1  ? 's' : '') + " selected", 1),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showCategoryWithProductModal()), ["prevent"])),
                        class: "bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest hover:bg-theme-green hover:text-white",
                        for: ""
                      }, "SELECT")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.categoryWithproductObj.active)
      ? (_openBlock(), _createBlock(_component_CategoryWithProductModal, {
          key: 0,
          title: "Exempt Items",
          closeClick: _ctx.closeCategoryWithProductModal,
          actionClick: _ctx.setCategoriesWithProduct
        }, null, 8, ["closeClick", "actionClick"]))
      : _createCommentVNode("", true)
  ], 64))
}